"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSectionAndRecipeIdQuery = void 0;
const client_1 = require("@apollo/client");
exports.getSectionAndRecipeIdQuery = client_1.gql `
  query GetSectionAndRecipeId($cookbookId: String!) {
    getSectionAndRecipeId(cookbookId: $cookbookId) {
      sectionId
      recipeId
    }
  }
`;
//# sourceMappingURL=getSectionAndRecipeId.js.map